import styled from '@emotion/styled';

export const SDangerActionItem = styled.div`
  color: #ff4d4f;
`;

export const SStatusCell = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const STopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
